import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9644102a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-editor" }

import { computed, onMounted, ref } from 'vue'
import Editor from 'vue-image-markup'
import { Loading3QuartersOutlined, ArrowRightOutlined, HighlightOutlined, UndoOutlined, SaveOutlined } from '@ant-design/icons-vue'
import axios from 'axios'
import { WrappedResponse } from 'vue-api-query'

interface MediaItem {
  id:number
  file_name:string
  url:string
  type:string
  size:string
  note:string|null
}

interface Props {
  mediaItem:MediaItem
}

interface EditorType {
  setBackgroundImage: (image:string) => void,
  uploadImage: (file:{ target: { files: File[] } }) => void,
  set: (tool:string, settings:{ stroke:string }) => void,
  undo: () => void,
  saveImage: () => string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEditor',
  props: {
    mediaItem: null
  },
  emits: ['imageEdited'],
  setup(__props: any, { emit }) {

const props = __props as {
  mediaItem:MediaItem
};




const screenWidth = computed(() => window.innerWidth)
const editor = ref<EditorType|null>(null)
const currentActiveTool = ref('circle')

onMounted(() => {
  setTool('circle')
  fetchFile(props.mediaItem.id, props.mediaItem.file_name, props.mediaItem.type).then((file:File) => {
    if (editor.value !== null) {
      editor.value.uploadImage({ target: { files: [file] } })
    }
  })
})

function setTool (tool:string) : void {
  if (editor.value !== null) {
    editor.value.set(tool, { stroke: 'orange' })
    currentActiveTool.value = tool
  }
}

function storeImage () : void {
  if (editor.value !== null) {
    const editedFile = editor.value.saveImage()
    base64ToFile(editedFile, props.mediaItem.file_name, 'image/png').then((file:File) => {
      emit('imageEdited', { file: file, mediaId: props.mediaItem.id })
    })
  }
}

async function fetchFile (id:number, name:string, type:string): Promise<File> {
  const r:WrappedResponse<any> = await axios.get(process.env.VUE_APP_API_URL + '/media/' + id + '/download', { responseType: 'arraybuffer' })
  return new File([r.data], name, { type: type })
}

async function base64ToFile (base64: string, name:string, type:string): Promise<File> {
  const r:Response = await fetch(base64)
  const blob:Blob = await r.blob()
  return new File([blob], name, { type: type })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["editor-tools-top", {'small' : _unref(screenWidth) < 600}])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["tool", {'activeTool' : currentActiveTool.value === 'circle'}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (setTool('circle')))
      }, [
        _createVNode(_unref(Loading3QuartersOutlined))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tool", {'activeTool' : currentActiveTool.value === 'arrow'}]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (setTool('arrow')))
      }, [
        _createVNode(_unref(ArrowRightOutlined))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tool", {'activeTool' : currentActiveTool.value === 'freeDrawing'}]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (setTool('freeDrawing')))
      }, [
        _createVNode(_unref(HighlightOutlined))
      ], 2),
      _createElementVNode("div", {
        class: "tool",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (editor.value.undo()))
      }, [
        _createVNode(_unref(UndoOutlined))
      ])
    ], 2),
    _createVNode(_unref(Editor), {
      canvasWidth: _unref(screenWidth) < 600 ? 300 : 520,
      canvasHeight: _unref(screenWidth) < 600 ? 300 : 520,
      ref_key: "editor",
      ref: editor
    }, null, 8, ["canvasWidth", "canvasHeight"]),
    _createElementVNode("div", {
      class: _normalizeClass(["editor-tools-bottom", {'small' : _unref(screenWidth) < 600}])
    }, [
      _createElementVNode("div", {
        class: "tool",
        onClick: storeImage
      }, [
        _createVNode(_unref(SaveOutlined))
      ])
    ], 2)
  ]))
}
}

})